// extracted by mini-css-extract-plugin
module.exports = {"CatImage":"CatImage_CatImage__2szcj"};